import React, { useContext } from "react";
import { useStores } from "../core/stores/rootStore";
import { Navigate, useLocation } from "react-router-dom";
import PrivateLayout from './layouts/PrivateLayout';

const RequireAuth = ({ activeFor,children }) => {
    let location = useLocation();
    const {loginStore}= useStores();
    const { isLoggedIn,accountInfo } = loginStore;

    if (!isLoggedIn()) {
        
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (activeFor) {        
        if (activeFor?.indexOf(accountInfo.role) > -1) { return (<PrivateLayout>{children}</PrivateLayout>); }
        else { return <Navigate to="/" replace /> }
    } else {
        return (<PrivateLayout>{children}</PrivateLayout>);
    }
    
    
    
}

export default RequireAuth;
